var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgReset = function SvgReset(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 16c1.671 0 3-1.331 3-3s-1.329-3-3-3-3 1.331-3 3 1.329 3 3 3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.817 11.186a8.9 8.9 0 0 0-1.355-3.219 9 9 0 0 0-2.43-2.43 8.95 8.95 0 0 0-5.057-1.535V2L8 5l3.975 3V6.002a6.961 6.961 0 0 1 3.937 1.193 7.004 7.004 0 0 1 1.894 9.718 7.028 7.028 0 0 1-4.394 2.946 7.1 7.1 0 0 1-2.822 0A7.002 7.002 0 0 1 5 13H3a9 9 0 0 0 1.539 5.034 9.1 9.1 0 0 0 2.428 2.428A8.95 8.95 0 0 0 12 22q.917 0 1.814-.183a9.01 9.01 0 0 0 5.649-3.786A8.95 8.95 0 0 0 21 13q0-.917-.183-1.814"
  })));
};
export default SvgReset;